export const lerp = (a, b, n) => (1 - n) * a + n * b;
export const clamp = (number, min, max) => Math.max(min, Math.min(number, max));
export const progress = (val, min, max) => val / (max - min) + min;
export const pad = (num, places) => String(num).padStart(places, '0');
export const group = (arr, k) => arr.reduce((r, c) => (r[c[k]] = [...r[c[k]] || [], c], r), {});
